export default __webpack_public_path__ + "static/media/Mobile_Banner_IPRU_EDGE_cropped.a9560c5a.jpg";